import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export const navigationDrawerSectionTemplate = html `<template tabindex="-1">
  <chameleon-typography variant="caption-medium-strong" tag="h2"><slot></slot></chameleon-typography
  ><slot name="end"></slot>
</template>`;
export class NavigationDrawerSectionComponent extends ChameleonElementMixin(FoundationElement) {
}
